import { useEffect, useRef } from "react";

type CSS_UNITS = "cm"|"mm"|"in"|"px"|"pt"|"pc"|"em"|"ex"|"ch"|"rem"|"vw"|"vh"|"vmin"|"vmax"|"%";
type LimitLinesProps = React.DetailedHTMLProps<React.HTMLAttributes<HTMLDivElement>, HTMLDivElement> & {
  children: React.ReactNode;
  lines?: number;
  lineHeight?: `${number}${CSS_UNITS}`;
};

export default function LimitLines({ children, lines = 2, lineHeight = "1.5em", ...rest }: LimitLinesProps) {
  const [lineHeightNS, lineHeightUnit] = lineHeight.match(/^(\d*(?:\d\.|\.\d)?\d*)(.+)$/)?.slice(1);
  const lineHeightN = parseFloat(lineHeightNS);
  const ref = useRef(null);

  // annoyingly, React will not let us set non-standard CSS properties using the normal `style={{ ... }}`
  // approach, so we have to grab the HTML element.
  useEffect(() => {
    if (!ref.current) return;
    ref.current.style["overflow"] = "hidden";

    // limit to N lines:

    // widely supported but non-standard
    ref.current.style["display"] = "-webkit-box";
    ref.current.style["-webkit-line-clamp"] = lines;
    ref.current.style["-webkit-box-orient"] = "vertical";
    ref.current.style["line-clamp"] = lines;

    // this backup comes close to the same behavior in case the above fails; ellipsis will not show
    ref.current.style["line-height"] = lineHeight;
    ref.current.style["max-height"] = `${lineHeightN * lines}${lineHeightUnit}`;
  }, [ref.current]);

  return <div ref={ref} {...rest}>{children}</div>
}
